<template>
<div>
    <v-card>
        <v-card-title v-html="header">
        </v-card-title>

        <v-card-text :class="$style.vCard">
            <v-form v-model="valid_form" ref="form" v-on:submit.prevent="">
                <div :class="$style.questions" v-html="body"/>
                <div v-html="subtext"/>

                <div v-for="group in question.config.groups" :key="'group_'+group.id" :class="$style.answers">
                    <div v-html="group.label[$language()]"></div>
                    
                    <v-select 
                        :key="'group_'+group.id+'select'" 
                        :items="select_options(group.id)" 
                        v-model="value[group.id]">
                        <template v-slot:selection="{ item }">
                            <div v-html="item.text" :class="$style.selectionItemTextWrapper"></div>
                        </template>
                        <template v-slot:item="{ item }">
                            <div v-html="item.text" :class="$style.selectionItemTextWrapper"></div>
                        </template>
                    </v-select>
                    <template v-for="input in group.inputs">
                        <template v-if="enableOther[group.id][input.id]">
                            <v-text-field 
                                :key="'group_'+input.id+'_select_other'" 
                                :autofocus="true" 
                                :disabled="!enableOther[group.id][input.id]" 
                                @keyup="other[group.id][input.id] ? other[group.id][input.id] = other[group.id][input.id].trimStart() : other[group.id][input.id]"
                                v-model="other[group.id][input.id]" 
                                >
                                <template v-slot:label>
                                    <str index='survey > label please_specify' />
                                </template>
                            </v-text-field>
                        </template>
                    </template>
                </div>     
            </v-form>       
        </v-card-text>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>
const controller = require("./controllers/select.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('select-question',controller);
module_config.methods.select_options = function(group_id){
    var options = [];
    var groups = this.question.config.groups;
    
    for(let g=0; g<groups.length; g++){
        var group = groups[g];

        if(group.id == group_id){
            for(let input_id in group.inputs){
                var input = group.inputs[input_id];
                
                options.push({
                    text: ( (this.survey.mode=='dev' || this.survey.mode=='test') ? "["+input.value+"] " : '') + input.label[this.$language()],
                    value: input.value
                })
            }
            break;
        }
    }

    return options;
}
export default module_config;
</script>

<style module>
/* .answers {
    margin-left: 90px;
} */
.vCard {
    padding: 19px 140px;
    width: 100%;
    margin-bottom: 0px;
}

.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
}

.questions {
    font-size:18px; 
    margin: 0px 0px 20px;
    color:black;
}

.selectionItemTextWrapper p {
    margin-bottom: 0px !important;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.vCard {
    margin: 0px !important;
    width: 100% !important;
    padding: 0px 10px;
}

.questions {
    width: 95%;
    margin:0px !important;
}

}

</style>


